import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@wayout-admin/util';
import { first, map, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CanActivateAuthGuard implements CanActivate {
	private readonly authService = inject(AuthService);
	private readonly router = inject(Router);

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.authService.userToken$.pipe(
			map((token) => {
				if (token) {
					this.router.navigate(['admin']);
					return false;
				}
				return true;
			}),
			first()
		);
	}
}
